import { ReactElement } from "react";
import CardBase from "../../../components/widgets/cardBase";
import { IDetailProps, IEAFProduction } from "../../../types";
import HeatChart from "./heatChart";
import CircularProgress from "@mui/material/CircularProgress";
import { Alert } from "@mui/material";
import { useFetch } from "../../../system/useFetch";

interface IComponentBProps {
  heatNumber: number;
  title: string;
  detail?: IDetailProps | undefined | null;
}

const ComponentD = ({ title, heatNumber, detail }: IComponentBProps): ReactElement => {
  const { loading, error, data } = useFetch<IEAFProduction>({ module: "eaf", query: "getHeatByNumber", payload: { heatNumber } });

  return (
    <CardBase title={`${title} - ${data ? data.machine.name.toUpperCase() : ""}`} detail={detail}>
      <>
        {loading && <div className="text-center"><CircularProgress /></div> }
        {error && <Alert severity="warning">{error.message}</Alert>}
        {data && <HeatChart productionData={data} selected={null}/> }
      </>
    </CardBase>
  );
};

export default ComponentD;
